import { KeyRound, Loader2, Lock, MessageCircle } from "lucide-react";
import { useState } from "react";
import { Reveal } from "./Reveal";
import { api, openChat } from "../../lib/api";
import { useContent, pick } from "../../lib/content";

// Textes provisoires — à remplacer par vos propres formulations quand vous les envoyez
const WORKS = [
  ["Briller comme une étoile", "Rituel d'éclat : attirer les regards, se faire remarquer et rayonner dans tous vos milieux."],
  ["Désenvoûtement", "Retirer les blocages, les mauvais sorts et les influences qui vous retiennent."],
  ["Protection", "Bouclier spirituel pour vous, vos proches, votre foyer ou votre commerce."],
  ["Chance & réussite", "Ouverture des chemins : jeux, affaires, examens et projets importants."],
  ["Libération de l'esprit", "Faire disparaître les cauchemars et les manques de sommeil, libérer totalement votre esprit."],
  ["Obéissance de l'enfant", "Pour les parents : aider un enfant qui n'écoute plus à retrouver l'écoute, le respect et le bon chemin."],
];

export const PrivateWork = () => {
  const c = useContent();
  const [paying, setPaying] = useState(false);
  const [payError, setPayError] = useState("");
  const pay = async () => {
    setPaying(true); setPayError("");
    try {
      const { data } = await api.post("/payments/checkout", { lookup_key: "travail_50", origin_url: window.location.origin, chat_sid: localStorage.getItem("wouffa_chat_session") });
      window.location.href = data.checkout_url;
    } catch { setPayError("Paiement momentanément indisponible. Réessayez ou passez par le chat."); setPaying(false); }
  };
  return (
  <section className="relative overflow-hidden border-y border-amber-900/40 bg-[#0d0b0a] py-20 md:py-28" data-testid="private-work-section">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_100%,rgba(139,0,0,0.18),transparent_60%)]" />
    <div className="relative mx-auto max-w-6xl px-5 md:px-10">
      <Reveal className="text-center">
        <KeyRound className="mx-auto h-7 w-7 text-amber-400" />
        <h2 className="mt-6 font-display text-3xl leading-tight text-amber-50 sm:text-4xl">
          D'autres travaux, en privé
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-stone-300 md:text-lg whitespace-pre-line">
          {pick(c, "private_intro",
            "Le Maître Wouffa traite aussi des travaux particuliers, sur mesure, dont le détail ne figure pas sur ce site. Expliquez votre situation dans la discussion instantanée : il vous répond personnellement, étudie votre cas et vous donne le travail à faire ainsi que le tarif. Tout reste strictement confidentiel.")}
        </p>
      </Reveal>
      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {WORKS.map(([title, txt], i) => (
          <Reveal key={title} delay={0.08 * i}>
            <div className="h-full rounded-2xl border border-amber-900/40 bg-[#181512] p-6" data-testid={`private-work-${i}`}>
              <p className="font-mono-x text-[11px] uppercase tracking-[0.25em] text-amber-500/70">0{i + 1}</p>
              <p className="mt-3 font-serif-it text-2xl italic text-amber-100">{title}</p>
              <p className="mt-3 text-sm leading-relaxed text-stone-300">{txt}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2} className="text-center">
        <div className="mx-auto mt-12 max-w-md rounded-3xl border border-amber-500/40 bg-[#181512] p-7" data-testid="private-work-price">
          <p className="font-mono-x text-[11px] uppercase tracking-[0.25em] text-amber-400">Certains travaux</p>
          <p className="mt-3 font-display text-4xl text-amber-50">50€</p>
          <p className="mt-2 text-sm text-stone-300">à confirmer par le Maître dans le chat, selon le travail.</p>
          <button onClick={pay} disabled={paying} data-testid="private-work-pay-button"
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-amber-400 px-6 py-3.5 text-sm font-bold uppercase tracking-wider text-stone-950 transition-transform duration-300 hover:scale-[1.02] disabled:opacity-50">
            {paying ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />} Payer les 50€ par carte
          </button>
          {payError && <p className="mt-3 text-xs text-red-400" data-testid="private-work-pay-error">{payError}</p>}
        </div>
        <button onClick={() => openChat("Bonjour Maître, j'ai un travail particulier à vous demander en privé. Ma situation est : ")}
          data-testid="private-work-chat-button"
          className="mt-8 inline-flex items-center gap-3 rounded-full border border-amber-500/60 px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-amber-200 transition-colors duration-300 hover:bg-amber-400 hover:text-stone-950">
          <MessageCircle className="h-4 w-4" /> Demander un travail en privé
        </button>
      </Reveal>
    </div>
  </section>
  );
};
